import request from '@/utils/request'


// 查询设备列表
export function listJoe(query) {
  return request({
    url: '/joe/watch-devices/list',
    method: 'get',
    params: query
  })
}

// 查询设备分页
export function pageJoe(query) {
  return request({
    url: '/joe/watch-devices/page',
    method: 'get',
    params: query
  })
}

// 查询设备详细
export function getJoe(data) {
  return request({
    url: '/joe/watch-devices/detail',
    method: 'get',
    params: data
  })
}

// 新增设备
export function addJoe(data) {
  return request({
    url: '/joe/watch-devices/add',
    method: 'post',
    data: data
  })
}

// 修改设备
export function updateJoe(data) {
  return request({
    url: '/joe/watch-devices/edit',
    method: 'post',
    data: data
  })
}

// 删除设备
export function delJoe(data) {
  return request({
    url: '/joe/watch-devices/delete',
    method: 'post',
    data: data
  })
}
